import React, { Component } from 'react';
import classnames from 'classnames';

import FormSubmit from '../../../containers/Forms/FormSubmit';
import { route } from '../../../config/constants';
import tryMe from '../../../helpers/tryMe';
import { history } from 'store/createStore';

export default class FormSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      withFocus: false,
      collapsedWidth: null,
    };
    this.formRef = null;
    this.sizerRef = null;
  }

  UNSAFE_componentWillMount() {
    const pathname = this.props.location.pathname;
    const onSearchPage = pathname.includes(route.SLATE_VIEW_SEARCH_REDIRECT);

    let initialSearchString = '';
    if (onSearchPage) {
      const numberOfSearcStringInUrl = 2;
      initialSearchString = pathname.split('/')[numberOfSearcStringInUrl] || '';
    }

    this.props.actions.setFormState({
      search: initialSearchString,
    });
  }

  componentDidMount() {
    const form = document.getElementsByClassName('search-form')[0];
    form.addEventListener('focus', this.addFocus, true);
    form.addEventListener('blur', this.removeFocus, true);

    // Measure collapsed width using the hidden sizer element
    this.measureCollapsedWidth();

    this.previousPathname = window.location.pathname;
    this.unlisten = history.listen((location) => {
      const wasOnSearchPage = this.previousPathname.includes(route.SLATE_VIEW_SEARCH_REDIRECT);
      const isOnSearchPage = location.pathname.includes(route.SLATE_VIEW_SEARCH_REDIRECT);

      if (wasOnSearchPage && !isOnSearchPage) {
        this.props.actions.handleClear();
        this.props.actions.fetchReset();
      }

      this.previousPathname = location.pathname;
    });
  }

  measureCollapsedWidth = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (this.sizerRef) {
          // Calculate collapsed width: sizer width + icon + padding
          // Icon is 14px + 10px margin-right = 24px
          // Form padding is 12px left + 17px right = 29px
          const sizerWidth = this.sizerRef.offsetWidth;
          const collapsedWidth = sizerWidth + 24 + 33;
          this.setState({ collapsedWidth });
        }
      });
    });
  }

  componentDidUpdate(prevProps) {
    // Re-measure width when account changes (placeholder text changes)
    const prevAccountId = prevProps.currentAccount ? prevProps.currentAccount.uuid : null;
    const currentAccountId = this.props.currentAccount ? this.props.currentAccount.uuid : null;

    if (prevAccountId !== currentAccountId) {
      this.measureCollapsedWidth();
    }
  }

  componentWillUnmount() {
    const form = document.getElementsByClassName('search-form')[0];
    form.removeEventListener('focus', this.addFocus, true);
    form.removeEventListener('blur', this.removeFocus, true);

    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    const {
      actions,
      state,
      t,
      currentAccount,
      errors,
    } = this.props;
    const name = currentAccount ? currentAccount.name : '';
    const placeholder = `${t('search:search')} ${name}`;

    const isExpanded = this.state.withFocus || (state.search && state.search.length >= 1);
    const { collapsedWidth } = this.state;

    // Use explicit width for animation (collapsed uses measured width, expanded uses 100%)
    const formStyle = collapsedWidth && !isExpanded
      ? { width: collapsedWidth }
      : isExpanded
        ? { width: '100%' }
        : {};

    return (
      <form
        ref={(ref) => { this.formRef = ref; }}
        className={classnames('search-form', { expanded: isExpanded })}
        style={formStyle}
        onKeyPress={actions.handleKeyPress}
        onClick={(e) => {
          const isClearButton = e.target.closest('button');
          if (!isClearButton && this.inputRef) {
            this.inputRef.focus();
          }
        }}
      >
        {/* Hidden sizer element to measure collapsed width even when expanded */}
        <span
          ref={(ref) => { this.sizerRef = ref; }}
          className="search-sizer"
          aria-hidden="true"
        >
          {placeholder}
        </span>
        <i className="material-icons search-icon">search</i>
        <div className="search-input-wrapper" data-placeholder={placeholder}>
          <input
            ref={(ref) => { this.inputRef = ref; }}
            type="text"
            name="search"
            className="search-input"
            placeholder={placeholder}
            value={tryMe(state).search || ''}
            onChange={(e) => actions.handleChange(e)}
            onBlur={(e) => actions.handleBlur(e)}
            autoComplete="off"
          />
        </div>
        {state.search && state.search.length >= 1 && (
          <button
            type="button"
            className="search-clear"
            onMouseDown={(e) => {
              e.preventDefault();
            }}
            onClick={(e) => {
              e.stopPropagation();
              const onSearchPage = window.location.pathname.includes(route.SLATE_VIEW_SEARCH_REDIRECT);
              this.props.actions.handleClear();
              this.props.actions.fetchReset();
              if (onSearchPage) {
                history.push(route.ROOT);
              }
            }}
          >
            <i className="material-icons">close</i>
          </button>
        )}
        <FormSubmit
          title={t('search:search')}
          style={{ display: 'none' }}
          handleSubmit={actions.handleSubmit}
          handleMouseDown={actions.handleMouseDown}
          entityName={state.entityName}
        />
        {errors && errors.search && (
          <div
            className={classnames({
              'search-error': true,
              hidden: !this.state.withFocus,
            })}
          >
            {errors.search}
          </div>
        )}
      </form>
    );
  }

  addFocus = () => this.setState({ withFocus: true });

  removeFocus = () => this.setState({ withFocus: false });
}
